(() => {
  const CUSTOM_COMPONENT_NAME = "cfs-dynamic-engraving";
  const PRODUCT_CONFIG_SCRIPT_SELECTOR = `script[type="application/json"][x-${CUSTOM_COMPONENT_NAME}-product]`;
  const SELECTED_VARIANT_CONFIG_SCRIPT_SELECTOR = `script[type="application/json"][x-${CUSTOM_COMPONENT_NAME}-selected-variant]`;
  const HIDDEN_CLASS_NAME = "cfs-dynamic-engraving--hidden";
  const INFINITE_OPTIONS_SELECTOR = "#infiniteoptions-container";

  const DEFAULT_TOTAL_LINES = 4;
  const DEFAULT_TOTAL_CHARACTERS = 20;

  class CFSDynamicEngraving {
    static __instance = null;

    product = null;
    selectedVariant = null;

    static mount(product, selectedVariant) {
      if(!this.__instance) {
        this.__instance = new CFSDynamicEngraving(product, selectedVariant);
        this.__instance.init();
      }

      return this.__instance;
    }

    constructor(product, selectedVariant) {
      this.product = product;
      this.selectedVariant = selectedVariant || this.product.variants[0];
    }

    get infiniteOptionsEl() {
      return document.querySelector(INFINITE_OPTIONS_SELECTOR);
    }

    get engravingConfig() {
      // Iterate over each tag, and find the matching config "cfs-{size}-{lines}x{characters}"
      for(const tag of this.product.tags) {
        if(!tag.startsWith("cfs-")) { continue; }

        const matches = /cfs-(\w+)-(\d+)x(\d+)/gi.exec(tag);

        if(!matches) { continue; }

        const [ _, size, lines, characters ] = matches;

        // Use the selected variant to determine the correct engraving config
        if( this.selectedVariant.title.toLowerCase().includes(size) ) {
          return {
            lines: parseInt(lines),
            characters: parseInt(characters)
          }
        }
      }

      return {
        lines: DEFAULT_TOTAL_LINES,
        characters: DEFAULT_TOTAL_CHARACTERS
      }
    }

    init() {
      document.addEventListener('on:variant:change', this.onVariantChange.bind(this));

      // Observe the infinite options element for changes
      const observer = new MutationObserver(this.updateEngravingOptions.bind(this));
      observer.observe(this.infiniteOptionsEl, { childList: true, subtree: true });

      // Do an initial update of the engraving options
      this.updateEngravingOptions();
    }

    onVariantChange(event) {
      this.selectedVariant = event.detail.variant;
      this.updateEngravingOptions();
    }

    updateEngravingOptions() {
      if(!this.infiniteOptionsEl) {
        console.warn('CFSDynamicEngraving: Infinite options element not found');
        return;
      }

      // Gather all of the text inputs
      const inputElements = this.infiniteOptionsEl?.querySelectorAll('input[type="text"]');
      
      // Map those inputs to their parent line elements
      let lineElements = [];
      inputElements.forEach((input) => {
        lineElements.push(input.parentElement.parentElement);
      });
      
      // Only show the correct number of lineElements based on the engraving config
      // Update the max length and remove any additional characters
      // Remove all characters from disabled inputs
      const { lines, characters } = this.engravingConfig;
      inputElements.forEach((inputElement, index) => {
        const isHidden = index >= lines;
        const lineElement = inputElement.parentElement.parentElement;

        lineElement.classList.toggle(HIDDEN_CLASS_NAME, isHidden);

        if(!isHidden) {
          inputElement.maxLength = characters;
          inputElement.value = inputElement.value.slice(0, characters);
        } else {
          inputElement.value = '';
        }
      });
    }
  }

  // Mounting routine
  const onLoad = () => {
    const csfCustomElement = document.querySelector(CUSTOM_COMPONENT_NAME);
    if(!csfCustomElement) {
      console.error('CFSDynamicEngraving: Custom element not found');
      return;
    }

    const productScriptElement = csfCustomElement.querySelector(PRODUCT_CONFIG_SCRIPT_SELECTOR);
    if(!productScriptElement) {
      console.error('CFSDynamicEngraving: Product script element not found');
      return;
    }

    const product = JSON.parse(productScriptElement.textContent);
    if(!product) {
      console.error('CFSDynamicEngraving: Product data not found');
      return;
    }

    let selectedVariant = null;
    const selectedVariantScriptElement = csfCustomElement.querySelector(SELECTED_VARIANT_CONFIG_SCRIPT_SELECTOR);
    
    if(selectedVariantScriptElement) {
      selectedVariant = JSON.parse(selectedVariantScriptElement.textContent);
    } else {
      console.warn('CFSDynamicEngraving: Selected variant data not found');
    }

    document.removeEventListener('DOMContentLoaded', onLoad);

    CFSDynamicEngraving.mount(product, selectedVariant);
  }

  document.addEventListener('DOMContentLoaded', onLoad);
})();